import { createAsyncThunk } from '@reduxjs/toolkit'
import { Laboratory, LabOrder } from '@dataTypes/lab.types'
import { labInitialData } from '@components/pages/Lab/labInitialData'
import { laboratories } from '@assets/mockdata/Lab/labData'

export const fetchLabOrders = createAsyncThunk<LabOrder[]>(
  'api/lab/fetch/orders',
  async (_, { rejectWithValue }) => {
    try {
      return labInitialData
    } catch (err) {
      return rejectWithValue('Failed to fetch lab orders')
    }
  },
)

export const addLabOrder = createAsyncThunk<LabOrder, LabOrder>(
  'api/lab/add/order',
  async (order, { fulfillWithValue }) => {
    return fulfillWithValue(order)
  },
)

export const updateLabOrder = createAsyncThunk<LabOrder, LabOrder>(
  'api/lab/update/order',
  async (updatedOrder, { fulfillWithValue, rejectWithValue }) => {
    try {
      return fulfillWithValue(updatedOrder)
    } catch (err) {
      return rejectWithValue('Failed to update lab order')
    }
  },
)

export const deleteLabOrder = createAsyncThunk<string, string>(
  'api/lab/delete/order',
  async (orderNo, { fulfillWithValue, rejectWithValue }) => {
    if (!orderNo) return rejectWithValue('Order not found')
    return fulfillWithValue(orderNo)
  },
)

export const fetchLaboratories = createAsyncThunk<Laboratory[]>(
  'api/laboratories/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return laboratories
    } catch (err) {
      return rejectWithValue('Failed to fetch laboratories')
    }
  },
)

export const addLab = createAsyncThunk<Laboratory, Laboratory>(
  'api/laboratories/add',
  async (lab, { fulfillWithValue }) => {
    return fulfillWithValue(lab)
  },
)

export const updateLab = createAsyncThunk<Laboratory, Laboratory>(
  'api/laboratories/update',
  async (lab, { fulfillWithValue, rejectWithValue }) => {
    try {
      return fulfillWithValue(lab)
    } catch (err) {
      return rejectWithValue('Failed to update laboratory')
    }
  },
)

export const deleteLab = createAsyncThunk<string, string>(
  'api/laboratories/delete',
  async (labId, { fulfillWithValue, rejectWithValue }) => {
    if (!labId) return rejectWithValue('Lab ID not found')
    return fulfillWithValue(labId)
  },
)
